import { Component } from '@angular/core';

@Component({
    templateUrl: './transfer-credits-help.component.html',
    styleUrls: ['./transfer-credits-help.component.scss'],
    standalone: false
})
export class TransferCreditsHelpComponent{}

